import { render, staticRenderFns } from "./signupPage.vue?vue&type=template&id=fb24de88&scoped=true&"
import script from "./signupPage.vue?vue&type=script&lang=js&"
export * from "./signupPage.vue?vue&type=script&lang=js&"
import style0 from "./signupPage.vue?vue&type=style&index=0&id=fb24de88&scoped=true&lang=less&"
import style1 from "./signupPage.vue?vue&type=style&index=1&id=fb24de88&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb24de88",
  null
  
)

export default component.exports